import MetricsController from "./pages/timesheet/components/metrics/metrics.controller";

class AppController {
  constructor($scope) {
    "ngInject";
    $scope.rightSidebar = true;
    $scope.notLogin = true;
    $scope.events = [];
  }

}

export default AppController;



// WEBPACK FOOTER //
// ./client/app.controller.js